import PageProtected from "../../components/Page/PageProtected";
import MainSection from "./MainSection";

export default function MainWelcome() {
    
return (
<>

    <PageProtected
        
        headline={'Precision Health Cockpit'}  
        main = {<>
        <MainSection />
        </>}
    />

</>
)}